module.exports = __webpack_public_path__ + "img/GR014N.f7f256a8.png";